/**
 * Entries that hold from a day on (`validFrom`, YYYY-MM-DD): a supplier's discounts and transport tariffs, the steps
 * of an Objektpreis. ISO days compare as text. No imports: the supplier store reads it while the app starts, before
 * Pinia.
 */

/** The entry in force on `day`: the latest that has begun by then, or null. One without a day counts for none. */
export const inForceOn = (entries, day) =>
  (entries ?? []).reduce(
    (latest, entry) =>
      entry?.validFrom && entry.validFrom <= day && (!latest || entry.validFrom > latest.validFrom) ? entry : latest,
    null
  )

/** The entries still to come after `day`, the soonest first. */
export const upcomingAfter = (entries, day) =>
  (entries ?? [])
    .filter(entry => entry?.validFrom && entry.validFrom > day)
    .sort((a, b) => a.validFrom.localeCompare(b.validFrom))
